<template>
  <div class="box mt-5">
    <div class="row">
      <div class="col-md-12 m-3">
        <h3> Extras <ShowHideEye :showSection="showSection" @toggle="showSection = !showSection"/> </h3>   
      </div>
    </div>
    <div class="row" v-if="showSection">
      <div class="col-md-12">
        <form class="form wrap" v-on:submit.prevent="addExtra">
          <div class="row">
            <div class="col-md-4">
              <div v-if="extras">
                <label>Extra</label>
                <v-select
                  required
                  id="extra"
                  v-model="newExtra"
                  label="name"
                  placeholder="Select an extra"
                  :options="extras"
                  v-on:change="handleExtraSelectionChange"
                >
                  <template slot="option" slot-scope="option">
                    {{ option.name }} - {{ option.price | formatCurrency }}
                  </template>
                </v-select>
              </div>
            </div>
            <div class="col-md-2">
              <div>
                <label for="qty">Quantity</label>
                <input class="extra_qty" type="number" id="qty" v-model="newExtraQty" min="1" :readonly="disableQTY">
              </div>
            </div>
            <div class="col-md-3">
              <label for="extra_note">Note</label>
              <textarea id="extra_note" style="resize:none" cols="5" v-model="newExtraNote" placeholder="Extra Note"></textarea>
            </div>
            <div class="col-md-2 mt-4">
              <button type="submit" class="button button--small" v-if="userRole == 1">Add extra to booking</button>
    
            </div>
          </div>
          
    
    
        </form>
    
        <table class="table" cellspacing="0" cellpadding="0" v-if="bookingExtras.length > 0">
          <thead>
            <tr>
              <th>Extra</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Note</th>
              <th>Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(extra, index) of bookingExtras" :key="extra.id" >
              <td>{{ extra.name }}</td>
              <td>{{ extra.price | formatCurrency }}</td>
              <td>{{ extra.pivot.qty }}</td>
              <td>
                {{ (extra.pivot.extra_note) ? extra.pivot.extra_note : '--' }}
              </td>
              <td>{{ (extra.price * extra.pivot.qty) | formatCurrency }}</td>
              <td class="table-action"><a v-on:click="deleteExtra(index)" class="icon icon--delete" v-if="userRole == 1">Delete</a></td>
            </tr>
            <tr>
              <td colspan="4"></td>
              <td>{{ extrasTotalPrice | formatCurrency }}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import ShowHideEye from './ShowHideEye.vue'
import {mapGetters} from 'vuex'
export default {
  name: 'BookingExtras',
  components: { ShowHideEye },
  props : {
    booking: Object,
    bookingExtras: Array,
    extrasTotalPrice: Number,
  },
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      let user_role = localStorage.getItem("user_role");
      if (user_role == 1) {
        this.showSection = true
      }
      return user_role
    }
  },
  mounted () {
    this.getExtras()
    this.userRole
  },
  data () {
    return {
      extras: null,
      newExtra: null,
      newExtraQty: 1,
      disableQTY:false,
      newExtraNote: null,
      showSection:false
    }
  },
  methods: {
    getExtras () {
      // @TODO: Old load up global extras and those that are linked to a tour that has an id within the booking.tour_bookings array
      this.$store.dispatch('setLoadStatus')
      let extraRequest = {
        booking_date:this.booking.created_at,
        tour_bookings:[]
      }
      if (this.booking.tour_bookings.length > 0) {
        this.booking.tour_bookings.forEach((element) => {

          let airlines = [];
          if (element.instance.flights.length > 0) {
            element.instance.flights.forEach((flight) => {
              airlines.push(flight.airline)
            })
          }

          extraRequest.tour_bookings.push({
            'tour_id': element.tour_id,
            'departure_date': element.check_in_date,
            'return_date' : element.check_out_date,
            airlines: [...new Set(airlines)]
          })
        })
      }
      
      fetch(`${this.$api}extras/get-booking/extra`, {
      //fetch(this.$api + 'extras', {
        method:'POST',
        body: JSON.stringify(extraRequest),
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.extras = response.data
        this.$store.dispatch('setLoadStatus')
      })
    },
    addExtra() {
      let availableBookingExtras = this.bookingExtras

      this.newExtra.pivot = {}
      this.newExtra.pivot.qty = this.newExtraQty
      this.newExtra.pivot.extra_note = this.newExtraNote

      availableBookingExtras.push(this.newExtra)
      this.requestExtraToServer(availableBookingExtras)

      // this.bookingExtras.push(this.newExtra)
      this.newExtra = null
      this.disableQTY = false
      this.newExtraQty = 1
      this.newExtraNote = null
      
    },
    deleteExtra(index) {
      this.bookingExtras.splice(index, 1);
      this.requestExtraToServer(this.bookingExtras)
    },
    handleExtraSelectionChange(){
      if(this.newExtra.for_per_person){
        if(this.booking.passengers.length > 0 ) {
          this.disableQTY = true
          this.newExtraQty = (this.booking.passengers.length > 0 ) ? this.booking.passengers.length : 1
        }else{
          this.disableQTY = false
        }
      }else{
        this.disableQTY = false
        this.newExtraQty = 1
      }
    },
    requestExtraToServer(booking_extras_obj) {
      this.$store.dispatch('setLoadStatus')
      fetch(`${this.$api}update-booking/update-extras/${this.booking.id}`, {
        method: 'POST',
        body: JSON.stringify({
          extras: booking_extras_obj
        }),
        headers: {
          "Content-Type": "application/json",
          'Accept': 'application/json',
          'Authorization': localStorage.getItem('token')
        }
      })
      .then(res => res.json())
      .then(response => {
        this.$store.dispatch('setLoadStatus')
        if (response.status) {
          this.$notify({
              type: 'success',
              title: response.message
          });
          this.$emit('handleBooking')
        }     
      })
      .catch((error) => {
        this.$store.dispatch('setLoadStatus')
        console.log(error);
      })
    }

  }
}
</script>
<style>
  input.extra_qty[readonly]{
    background-color: #e9ecef !important;
    
  }
</style>

